import { EventContentArg } from '@fullcalendar/core';
import { renderEventBar } from '../components/eventBarRenderer';

/**
 * 예약 이벤트 포맷터
 * - SRP: 예약 이벤트의 콘텐츠 생성만 담당
 * - 시간, 제목, 예약자 정보 표시
 */
export const renderBookingEvent = (eventInfo: EventContentArg) => {
  const backgroundColor = eventInfo.event.backgroundColor || '#1a73e8';
  const borderColor = eventInfo.event.borderColor || backgroundColor;
  const textColor = eventInfo.event.textColor || '#ffffff';

  // 이벤트 시간 포맷팅
  const startTime = new Date(eventInfo.event.start!);

  // 월간 뷰용: 시작~종료 시간 범위
  const h = startTime.getHours();
  const m = startTime.getMinutes();
  const ampm = h < 12 ? '오전' : '오후';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  const mm = String(m).padStart(2, '0');

  const endTimeShort = eventInfo.event.end ? new Date(eventInfo.event.end) : null;
  let formattedStartTimeShort = `${ampm} ${h12}:${mm}`;
  if (endTimeShort) {
    const eh = endTimeShort.getHours();
    const em = endTimeShort.getMinutes();
    const eampm = eh < 12 ? '오전' : '오후';
    const eh12 = eh % 12 === 0 ? 12 : eh % 12;
    const emm = String(em).padStart(2, '0');
    if (ampm === eampm) {
      formattedStartTimeShort = `${ampm} ${h12}:${mm}~${eh12}:${emm}`;
    } else {
      formattedStartTimeShort = `오전 ${h12}:${mm}~${eh12}:${emm}`;
    }
  }

  // 주간/일간 뷰용: 24시간제
  const endTime = eventInfo.event.end ? new Date(eventInfo.event.end) : null;
  const formattedStartTime = startTime.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).replace(/\s/g, '');
  const formattedEndTime = endTime ? endTime.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).replace(/\s/g, '') : '';

  const viewType = eventInfo.view.type;
  const title = eventInfo.event.title;

  // 월간 뷰: 애플 캘린더 스타일 (왼쪽 색상 바 + 제목, 오른쪽 시작 시간)
  if (viewType === 'dayGridMonth') {
    return {
      html: `
        <div style="
          height: 100%;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 0 4px 0 0;
          overflow: hidden;
          background-color: transparent;
        ">
          <span style="
            width: 5px;
            min-width: 5px;
            align-self: stretch;
            background-color: ${backgroundColor};
            border-radius: 2px;
          "></span>
          <span style="
            font-size: 10px;
            font-weight: 400;
            color: #636366;
            white-space: nowrap;
            flex: 0 0 80px;
            width: 80px;
          ">${formattedStartTimeShort}</span>
          <span style="
            font-size: 12px;
            font-weight: 400;
            color: #1c1c1e;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
            min-width: 0;
          ">${title}</span>
        </div>
      `
    };
  }

  // 주간/일간 뷰: 시간 · 제목 (left-border 스타일 유지)
  const timeRange = formattedEndTime ? `${formattedStartTime}-${formattedEndTime}` : formattedStartTime;
  return renderEventBar(`${timeRange} · ${title}`, backgroundColor, borderColor, textColor);
};
